<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link"
                        class="list-view-icon-btn"
                        v-b-tooltip.hover.bottom
                        title="Refrescar"
                        aria-label="Refrescar"
                        @click="filterData()">
                <AppIcon name="refresh" weight="600" />
              </b-button>
            </div>
          </div>
        </section>
      </b-card>

      <b-card>
        <b-row>
          <b-col lg="6">
            <b-table class="app-table cost-update-external-table"
                    ref="table"
                    responsive
                    :stacked="isMobileViewport ? 'md' : false"
                    sticky-header="60vh"
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :items="table.items"
                    :fields="table.fields"
                    :current-page="table.currentPage"
                    :per-page="table.perPage"
                    :busy="table.isBusy"
                    v-if="table.items.length || table.isBusy">

                <template v-slot:table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Cargando...</strong>
                  </div>
                </template>

                <template v-slot:cell(date)="data">
                  {{ moment(data.item.created_at).format('DD MMMM YYYY - HH:mm') }}
                </template>

                <template v-slot:cell(origen)="data">
                  {{ data.item.origen }}
                </template>

                <template v-slot:cell(count)="data">
                  <div v-if="parseFloat(data.item.count_rows)>0">
                    <div v-if="parseFloat(data.item.count_rows)==1">
                      <i><b>{{ data.item.count_rows }}</b> Registro</i>
                    </div>
                    <div v-else>
                      <i><b>{{ data.item.count_rows }}</b> Registros</i>
                    </div>
                  </div>
                  <div v-else>
                    <i>Sin Registros</i>
                  </div>
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right
                              no-caret
                              size="sm"
                              variant="link"
                              boundary="window"
                              :toggle-class="isMobileViewport ? 'cost-update-external-action-toggle-labeled' : 'app-table-action-toggle'"
                              :class="{ 'pull-right': !isMobileViewport }"
                              v-if="data.item.count_rows > 0">
                    <template #button-content>
                      <AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" />
                      <span v-if="isMobileViewport">Opciones</span>
                    </template>

                    <b-dropdown-item @click="download(data.item)">
                      <AppIcon name="download" /> Descargar
                    </b-dropdown-item>
                    <b-dropdown-header>Acciones</b-dropdown-header>
                    <b-dropdown-item @click="undo(data.item)">
                      <AppIcon name="eraser-fill" class="text-danger" /> Anular
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
            </b-table>
            <EmptyState v-else
                        icon="reports"
                        title="No se encontraron registros"
                        description="Todavía no se registraron actualizaciones de precios desde integraciones externas." />

            <div class="app-table-footer" v-if="table.tablePaginate">
              <span class="list-view-toolbar__count">{{ table.tablePaginate.total }} registros</span>
            </div>
          </b-col>
          <b-col lg="6">
            <section class="cost-update-help-panel">
              <div class="cost-update-help-panel__header">
                <span class="cost-update-help-panel__icon"><AppIcon name="help" /></span>
                <div>
                  <h6>Actualizaciones externas</h6>
                  <p>Precios modificados vía integraciones por API.</p>
                </div>
              </div>

              <p>Mostramos todas las <b>actualizaciones de precios</b> realizadas desde integraciones externas vía <b>API</b>.</p>

              <div class="cost-update-help-panel__block">
                <h6>Anular una actualización</h6>
                <p>Desde la opción <b>Anular</b>, el sistema vuelve el precio modificado a su estado anterior.</p>
              </div>
            </section>
          </b-col>
        </b-row>
      </b-card>

      <b-card body-class="py-2">
        <div class="list-view-footer">
          <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
            <AppIcon name="back" class="mr-1" />Volver
          </b-button>

          <nav v-if="table.tablePaginate">
            <b-pagination class="mb-0"
                          size="sm"
                          pills=""
                          :total-rows="table.tablePaginate.total"
                          :per-page="table.tablePaginate.per_page"
                          v-model="table.currentPage"
                          @input="filterData()" />
          </nav>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import moment from 'moment'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: {
      TabHeaderActions,
    },

    data: () => {
      return {
        access: {
          module_id: Modules.COSTOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudUpdateExternal',
        },
        table : {
          items: [],
          fields: [],
          currentPage: 1,
          perPage: 0,
          isBusy: false,
          tablePaginate: null,
        },
        isMobileViewport: false,
      }
    },

    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },

    mounted() {
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)

      this.loadFieldTable()
      this.filterData()
    },

    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },

    watch: {
      isMobileViewport() {
        this.loadFieldTable()
      }
    },

    methods: {
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },

      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },

      loadFieldTable() {
        this.table.fields = []
        this.table.fields.push({key: 'date', label: 'Fecha', class: "align-middle " + this.alignClass('text-left')})
        this.table.fields.push({key: 'origen', label: 'Origen', class: "align-middle " + this.alignClass('text-left')})
        this.table.fields.push({key: 'count', label: 'Registros', class: "align-middle " + this.alignClass('text-left')})
        this.table.fields.push({key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class: "align-middle " + this.alignClass('text-right')})
      },

      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },

      filterData() {
        this.table.isBusy = true

        var result = serviceAPI.obtenerUpdateExternalListCost(this.table.currentPage)
        result.then((response) => {
          var data = response.data
          this.table.tablePaginate = data

          this.table.items = data.data

          this.table.isBusy = false
        })
        .catch(error => {
          this.table.isBusy = false
          this.$awn.alert(Error.showError(error))
        });
      },

      download(item) {
        this.confirmDialog('¿Descargar registros?', {
          title: 'Descargar Registros',
          icon: 'download',
          okTitle: 'DESCARGAR',
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            this.$awn.info("Estamos procesando el archivo, por favor espere...");
            let data = JSON.parse(item.data_products)

            let csvContent = 'data:text/csv;charset=utf-8,' +
              Object.keys(data[0]).join(',') + '\n' +
              data.map(item => Object.values(item).join(',')).join('\n');

            let encodedUri = encodeURI(csvContent);
            let link = document.createElement('a');
            link.setAttribute('href', encodedUri);
            link.setAttribute('download', 'datos.csv');

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            loader.hide()
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        });
      },

      undo(item) {
        this.confirmDialog('Al anular esta modificación de precios, cada registro modificado volverá a su precio anterior. ¿Continuar con la anulación?', {
          title: 'Anulación de Precios',
          icon: 'eraser-fill',
          danger: true,
          okTitle: 'ANULAR',
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            var result = serviceAPI.anularUpdateExternalListCost({
              id: item.id,
            })
            result.then((response) => {
              loader.hide()

              this.filterData()

              this.$awn.success("Finalizamos la anulación de los precios modificados");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        });
      }
    }
  }
</script>

<style scoped>
  .cost-update-help-panel {
    background: var(--app-color-surface-subtle);
    border: 1px solid var(--app-color-border);
    border-radius: 8px;
    color: var(--app-color-text-secondary);
    font-size: var(--app-text-sm);
    padding: 14px;
  }
  .cost-update-help-panel p {
    margin-bottom: 10px;
  }
  .cost-update-help-panel__header {
    align-items: center;
    display: flex;
    gap: 10px;
    margin-bottom: 12px;
  }
  .cost-update-help-panel__header h6 {
    color: var(--app-color-text);
    font-size: var(--app-text-sm);
    font-weight: 700;
    margin: 0;
  }
  .cost-update-help-panel__header p {
    color: var(--app-color-text-muted);
    font-size: var(--app-text-xs);
    margin: 1px 0 0;
  }
  .cost-update-help-panel__icon {
    align-items: center;
    background: var(--app-color-primary-soft);
    border: 1px solid var(--app-color-primary-200);
    border-radius: 8px;
    color: var(--app-color-primary);
    display: inline-flex;
    flex: 0 0 34px;
    height: 34px;
    justify-content: center;
    width: 34px;
  }
  .cost-update-help-panel__block {
    border-top: 1px solid var(--app-color-border);
    margin-top: 12px;
    padding-top: 12px;
  }
  .cost-update-help-panel__block h6 {
    color: var(--app-color-text);
    font-size: var(--app-text-xs);
    font-weight: 700;
    margin-bottom: 6px;
    text-transform: uppercase;
  }
  .cost-update-help-panel__block p {
    margin-bottom: 0;
  }
  @media (max-width: 767.98px) {
    .cost-update-help-panel {
      margin-top: 12px;
    }
  }
</style>

<style>
  /* Kebab con texto "Opciones" visible en mobile (ABM sin drawer: la única
     forma de llegar a Descargar/Anular es esta acción, no puede quedar muda
     ni oculta). Alineado a la izquierda, como el resto del valor apilado. */
  .btn.cost-update-external-action-toggle-labeled {
    display: inline-flex !important;
    align-items: center;
    justify-content: flex-start;
    width: auto !important;
    height: auto !important;
    min-height: 0;
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    color: var(--app-color-text-secondary) !important;
    font-size: 13px;
    line-height: 1.15;
    white-space: nowrap;
  }
  .btn.cost-update-external-action-toggle-labeled:hover,
  .btn.cost-update-external-action-toggle-labeled:focus {
    color: var(--app-color-primary) !important;
    text-decoration: underline;
  }
  @media (max-width: 767.98px) {
    .cost-update-external-table.app-table.b-table-stacked-md > tbody > tr > td:last-child::before {
      content: attr(data-label) !important;
    }
  }
</style>
